import React, { use, useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../services/apiService';
import { Pagination,Modal } from 'antd';
import { EditOutlined,DeleteOutlined } from '@ant-design/icons';
import ConfirmDeleteModal from '../components/common/ConfirmDeleteModal';
import { toast } from 'react-toastify';

const Users = () => {

  const navigate = useNavigate();
  const [users,setUsers] = useState([]);
  const [total, setTotal] = useState(0); // Store total number of records for pagination
  const [currentPage, setCurrentPage] = useState(1); // Store current page for pagination     
  const [pageSize, setPageSize] = useState(10); // Store page size for pagination
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
    const fetchUsers = async (page, limit) => {
      try {
        const payload = {
          page,
          limit,
      };
        const response = await apiService('users', 'POST',payload);
        setUsers(response.data.records);
        setTotal(response.data.pagination.total);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
  useEffect(() => {
  

    fetchUsers(currentPage, pageSize);
  },  [currentPage, pageSize]);
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
};
const toggleStatus = async (user) => {    
  setSelectedUser(user);
  setShowModal(true);
  
  }
  const confirmDelete = async () => {
    try {
      await apiService(`users/${selectedUser.id}`, 'DELETE');
      toast.success("User status changed successfully!");
      fetchUsers(); // Or refetch list

    } catch (err) {
      console.error("Delete failed:", err);
    } finally {
      setShowModal(false);
    }
  };
  
  const handleEdit = (userId) => {
    navigate(`/edit-user/${userId}`);
  };
  return (
    <div className="container mx-auto p-4">
      {/* <h1 className="text-2xl font-bold mb-4">Users</h1> */}
       <div className="ml-auto flex gap-x-5 justify-end py-1"  >
                    {/* Import Button with icon */}
                    <button className="bg-[#287DD1] text-white px-6 py-3 rounded-md flex items-center gap-x-2 cursor-pointer" onClick={() => navigate("/add-user")} >
                        <span className="text-white">Add User</span>
                    </button>
    
                 
                </div>
      
      {/* Users Table */}
      <table className="min-w-full bg-white border border-gray-300 shadow-md rounded-lg">
        <thead>
          <tr>
            <th className="px-6 py-3 border-b text-left text-sm font-semibold text-gray-600">Name</th>
            <th className="px-6 py-3 border-b text-left text-sm font-semibold text-gray-600">Email</th>
            <th className="px-6 py-3 border-b text-left text-sm font-semibold text-gray-600">Status</th>

            <th className="px-6 py-3 border-b text-left text-sm font-semibold text-gray-600">Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={index} className="hover:bg-gray-100">
              <td className="px-6 py-4 border-b border-[#c8c8c8] text-sm text-gray-800">{user.username}</td>
              <td className="px-6 py-4 border-b border-[#c8c8c8]  text-sm text-gray-800">{user.email}</td>
              <td className="px-6 py-4 border-b border-[#c8c8c8] text-sm text-gray-800 text-white">
  <button
    className={`px-4 py-1 rounded-md text-white text-xs  cursor-pointer ${
      user.status === 1 ? 'bg-green-500' : 'bg-red-500'
    }`}
    onClick={() => toggleStatus(user)}
  >
    {user.status === 1 ? 'Active' : 'Inactive'}
  </button>
</td>
              <td  className="px-6 py-4 border-b border-[#c8c8c8] text-sm text-gray-800">
              <EditOutlined
                                onClick={() => navigate(`/edit-user/${user.id}`)}
                                style={{ marginRight: 8, cursor: "pointer" }}
                            />
                 {/* <DeleteOutlined     onClick={() => handleDelete(user)}
                                                style={{ cursor: "pointer",color:'red' }}
                                            /> */}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
        <div className="mt-4 flex justify-end">
                      <Pagination
                          current={currentPage}
                          pageSize={pageSize}
                          total={total}
                          onChange={handlePageChange}
                          showSizeChanger
                      />
                  </div>
                  <ConfirmDeleteModal
                    show={showModal}
                    user={selectedUser}
                    onCancel={() => setShowModal(false)}
                    onConfirm={confirmDelete}
                    title ="change status"
                    message={`Are you sure you want to change the status of ${selectedUser?.username}?`}
                  />

    </div>
  );
};
  
export default Users;